import { render, staticRenderFns } from "./ncform_editor.vue?vue&type=template&id=4753d573&"
import script from "./ncform_editor.vue?vue&type=script&lang=js&"
export * from "./ncform_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports